import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var BannerDetailsRes;
export const BannerDetailsTodo = createAsyncThunk('BannerDetails', async (id) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "Get",
            url: process.env.REACT_APP_API_URL + `banner_data/${id}`,
            params:{
                "banner_status": ""
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return BannerDetailsRes = res.data

    } catch (error) {
        return BannerDetailsRes = error.response.data
    }
})

const BannerDetailsSlice = createSlice({
    name: 'BannerDetails',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(BannerDetailsTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('equipmentList', state.data.response)
        });
        builder.addCase(BannerDetailsTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default BannerDetailsSlice.reducer; 